export const toDetail = (id: string) => {
  window.location.href = `${window.location.origin}/details/${id}`;
};
